<template>
    <div>
        <div id="therapyRow">
            <div class="row border-top" v-for="row in therapyRow" :key="row.count" :id="'therapyRow_' + row.count" :style=" row.count & 1 ? {'background' : '#f9f9f9'} : ''">
                <div class="col-10 p-5 border-right">
                    <therapyForm ref="therapyForm" :treatmentID="treatmentID" :rowID="row.count" :items="row.item"></therapyForm>
                </div>
                <div class="col-2 pt-5 d-flex align-items-center justify-content-center">
                    <div class="row">
                        <div class="col-md-6 pl-0">
                            <a class="link d-block" :title="$t('button_link.add') + $t('subMenu.salon_menu_therapy')" @click="addRow">
                                <i class="fas fa-2x fa-plus-circle text-success"></i>
                            </a>
                        </div>
                        <div class="col-md-6 pl-0">
                            <a v-if="therapyRow.length >1" class="link" :title="$t('button_link.remove') + $t('subMenu.salon_menu_therapy')" @click="removeRow">
                                <i class="fas fa-2x fa-trash text-danger"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="border-top pt-3 mt-3 mb-3">
            <button type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mb-2 mr-3" @click="returnTreatment">{{$t('button_link.cancel')}}</button>
            <button type="button" class="btn border-0 btn-dark btn-padding waves-effect waves-themed mb-2 mr-3" @click="previous">{{$t('button_link.prev')}}</button>
            <button type="button" class="btn border-0 btn-primary btn-padding waves-effect waves-themed mb-2" @click="saveTherapy">{{$t('button_link.next')}}</button>
        </div>
    </div>
</template>
<script>
import TherapyForm from './Therapy_Form'
export default {
    name: 'therapyItem',
    props: {
        treatmentID: Number
    },
    components:{
        TherapyForm
    },
    data(){
        return{
            therapyRow: [{count: 0, item: undefined}], count: 0, isAdd: false,
        }
    },
    methods:{
        closeModal(isError){
            this.$parent.$parent.$parent.$parent.isModalShow = false
        },
        previous(){
            this.$emit('previous', 2)
        },
        returnTreatment(){
            this.$emit('returnTreatment')
        },
        addRow(){
            this.isAddService = true;
            this.therapyRow.push({count: ++this.count, item: undefined});
        },
        removeRow(){
            this.therapyRow.pop();
            this.count = this.therapyRow.length - 1;
        },
        editTherapy(items){
            if(items.length != 0){
                if(items[0].length != 0){
                    var item = items[0]
                    this.therapyRow = []; this.count = 0;
                    for(var i=0; i<item.length; i++){
                        this.therapyRow.push({count: ++this.count, item: item[i]})
                    } 
                }
            }else{
                this.therapyRow= [{count: 0, item: {}}]
            }
        },
        setRequiredALert(label){
            this.$parent.$parent.$parent.$parent.setModal(this, true, true,  this.$i18n.t('message.error.required', {'item': this.$i18n.t(label)}));
        },
        validateField(field){
            var flag = true
           if(field.TnTherapyName == ''){
                this.setRequiredALert('label.title')
                flag = false
            }else if(field.TnTherapyVoucherID == 0){
                this.setRequiredALert('table.header.voucher')
                flag = false
            }
            
            return flag
        },
        saveTherapy(){
            var data = []
            for(var i=0; i<this.therapyRow.length; i++){
                var therapyData = this.$refs.therapyForm[i].setFormData();
                if(this.validateField(therapyData)){
                    data.push(therapyData);
                }
                
            }
            if(data.length == this.therapyRow.length){
                this.$emit('saveTherapy', data)
            }
           
        },
    },
    updated(){
        let $vm = this;
        if($vm.isAdd){
            var lastRow =  document.getElementById('therapyRow').lastChild
            lastRow.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
            $vm.isAdd = false;
        }
    }
}
</script>